import React from "react";
import { Link } from "react-router-dom";
import { NAV_ITEMS } from "./NavbarMenuConfig";

function NavLabel({ to, className, children }) {
  // Ako nema "to", ne koristimo <Link> (da ne pravi warning/bug),
  // nego običan <a> koji samo služi kao hover/label.
  if (to)
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );

  return (
    <a href="#nav" className={className} onClick={(e) => e.preventDefault()}>
      {children}
    </a>
  );
}

function DesktopMenuItems({ items, t }) {
  return items.map((item) => {
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;
    const liClass = hasChildren || item.forceHasSub ? "has-sub" : undefined;

    const label = (
      <NavLabel
        to={item.to}
        className={item.desktopArrow ? "link-with-icon" : undefined}
      >
        {t(item.labelKey)}{" "}
        {item.desktopArrow ? (
          <i className="fas fa-long-arrow-alt-right" />
        ) : null}
      </NavLabel>
    );

    return (
      <li key={item.id} className={liClass}>
        {label}
        {hasChildren ? (
          <ul>
            <DesktopMenuItems items={item.children} t={t} />
          </ul>
        ) : null}
      </li>
    );
  });
}

export function NavbarTopBar({ t }) {
  return (
    <div className="header-top second-header d-none d-md-block">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4 col-md-4 d-none d-lg-block">
            <div className="header-social">
              <span>
                {t("navbar.followUs")}
                <a
                  href="https://www.facebook.com/fpebar.me"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Facebook"
                  title="Facebook"
                >
                  <i className="fab fa-facebook-f" />
                </a>
                <a
                  href="https://www.instagram.com/fpepbar/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                  title="Instagram"
                >
                  <i className="fab fa-instagram" />
                </a>
                <a
                  href="https://www.youtube.com/@fpepbar"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Youtube"
                  title="Youtube"
                >
                  <i className="fab fa-youtube" />
                </a>
                <a
                  href="https://www.tiktok.com/@fpepbar"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Tiktok"
                  title="Tiktok"
                >
                  <i className="fab fa-tiktok" />
                </a>
                <a
                  href="https://www.linkedin.com/school/fpepbar/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on LinkedIn"
                  title="LinkedIn"
                >
                  <i className="fab fa-linkedin-in" />
                </a>
              </span>
            </div>
          </div>

          <div className="col-lg-8 col-md-8 d-none d-lg-block text-right">
            <div className="header-cta">
              <ul>
                <li>
                  <div className="call-box">
                    <div className="icon">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div className="text">
                      <span>{t("navbar.CallUs")}</span>
                      <strong>
                        <Link to="tel:+38268011311"> +382 68/003-113</Link>
                      </strong>
                    </div>
                  </div>
                </li>

                <li>
                  <div className="call-box">
                    <div className="icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="text">
                      <span>{t("navbar.Email")}</span>
                      <strong>
                        <Link to="mailto:fpebar@gmail.com">
                          fpebar@gmail.com
                        </Link>
                      </strong>
                    </div>

                    <div className="col-lg-8 col-md-8 d-none d-lg-block text-right">
                      <div className="text">
                        <span>{t("navbar.StudentPortal")}</span>
                        <strong>
                          <a
                            href="https://e-fpep.com/login/index.php?lang=sr_lt"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("navbar.Login")}
                            <i className="fas fa-long-arrow-alt-right" />
                          </a>
                        </strong>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function DesktopNav({ t, currentLanguage, changeLanguage }) {
  return (
    <div className="col-xl-8 col-lg-6">
      <div className="main-menu text-right text-xl-right">
        <nav id="mobile-menu">
          <ul>
            <DesktopMenuItems items={NAV_ITEMS} t={t} />

            {/* Language switch (ostaje kao posebna stavka) */}
            <li>
              {currentLanguage === "en" ? (
                <button
                  onClick={() => changeLanguage("me")}
                  className="language-button"
                >
                  <span className="flag-icon flag-icon-me" />
                </button>
              ) : (
                <button
                  onClick={() => changeLanguage("en")}
                  className="language-button"
                >
                  <span className="flag-icon flag-icon-gb" />
                </button>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default DesktopNav;
